import prepareUpdate from './prepareUpdate';

export default {
  prepareUpdate,
};
